/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var TextIcon = createIcon("TextIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#989898';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 34a2 2 0 110 4H10a2 2 0 110-4h18Zm10-8a2 2 0 110 4H10a2 2 0 110-4h28Zm0-8a2 2 0 110 4H10a2 2 0 110-4h28Zm0-8a2 2 0 110 4H10a2 2 0 110-4h28Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.TextIcon",
  "replaceColor": true
});